<template>
    <div class="dominfo-container">
        <v-flex v-if="isDomInfoAvaiable" class="order-wrapper" :class="actionType === 'Buy' || actionType === 'Bid' ? 'buy' : ''">
            <v-row no-gutters>
                <v-col>
                    <div class="card_label_thead">{{ $t('cases') }}</div>
                </v-col>
                <v-col>
                    <div class="card_label_thead card_label_thead_price">Price per case</div>
                </v-col>
            </v-row>

            <div class="bidsoffers-container" :class="domInfo.length > 4 ? 'more' : ''">
                <v-row v-for="(item, index) in bidsOrOffers" :key="index" no-gutters>
                    <template no-gutters>
                        <v-col>
                            <div class="card_label_tbody">{{ actionType === 'Buy' || actionType === 'Bid' ? item.buyQuantity : item.numberOfCases }}</div>
                        </v-col>
                        <v-col>
                            <div class="card_label_tbody card_label_thead_price">{{ actionType === 'Buy' || actionType === 'Bid' ? formatPrice(zero(item.buyPrice.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.'))) : formatPrice(zero(item.pricePerCase.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.')))}}</div>
                        </v-col>
                    </template>
                </v-row>
            </div>
        </v-flex>
        <v-flex v-else :style="{ flex: 1, justifyContent: 'center', alignItems: 'center', marginTop: 15 }">
            <div class="no-offers-available" :class="actionType === 'Buy' || actionType === 'Bid' ? 'no-bids' : ''">{{ actionType === 'Buy' || actionType === 'Bid' ? $t('buy3') : $t('buy4') }}</div>
        </v-flex>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { GWines} from '../store/getters';

    export default {
        props: {
            actionType : {
                type: String,
                reuqired: true
            }
        },
        name: "DomInfo",
        data() {
            return {
                isDomInfoAvaiable: false,
                bidsOrOffers: []
            }
        },
        computed: {
            ...mapGetters({
                domInfo: GWines.GET_SELECTED_WINE_INFO
            })
        },
        watch: {
            domInfo: {
                immediate: true,
                deep: true,
                handler (v) {
                    let orders = (this.actionType === 'Buy' || this.actionType === 'Bid') ? this.domInfo.offers : this.domInfo.bids

                    this.isDomInfoAvaiable = orders.length > 0;

                    this.bidsOrOffers = orders.length > 3 ? orders.slice(0, 3) : orders
                }
            }
        },
        methods: {
            formatPrice(price) {
                return `€ ${price}`
            },
            zero(item) {
                return item === 0 ? '-' : item
            }
        }
    }
</script>

<style scoped>
    .card_label_thead {
        font-size: 16px;
        font-weight: 300;
        height: 26px;
        padding: 0;
        color: #B2B2B2;
        text-align: left;
        padding-right: 9px;
    }
    .card_label_thead.warehouse {
        text-align: left;
    }
    .card_label_tbody {
        height: 53px;
        padding: 15px 9px;
        border-bottom: 1px solid #E6E6E6;
        color: #303030;
        font-size: var(--fs-base);
        font-weight: 300;
        text-align: left;
    }
    .card_label_thead_storage {
        text-align: left;
        padding-left: 0;
    }
    .card_label_thead_price {
        padding-right: 0;
    }
    .card_label_tbody.card_label_thead_storage img {
        position: relative;
        top: 2px;
        margin-right: 7px;
    }
    .no-offers-available {
        background: #FFFFFF;
        border: 1px solid #E6E6E6;
        color: #000000;
        text-align: center;
        height: 210px;
        font-size: 17px;
        font-weight: 300;
        font-family: 'Roboto', sans-serif;
        line-height: 210px;
    }
    .order-wrapper {
        height: auto;
    }
    .bidsoffers-container {
        height: 160px;
        overflow-y: auto;
    }

    @media (max-width: 767px) {
        .bidsoffers-container {
            height: auto;
            margin-bottom: 32px;
        }
    }
</style>
